<entity-search [entityName]="entityName" [showAllFilters]="showAllFilters"
               (entitySelected)="goToDetail($event)"
               (newEntityRequested)="newQuote($event)"></entity-search>
